import { HeadingProps } from "@made-people/blueprint-heading";

export const HeadingDefaults: HeadingProps = {
  variants: {
    headingSize: { initial: "sm", md: "lg", lg: "xl" },
    leadSize: { initial: "md", md: "lg" },
    eyebrowSize: { initial: "md", md: "lg" },
  },
};
